import initializeHistoryApiIntegration from '../historyApiIntegration/initializeHistoryApiIntegration';
import initializeObeyBackendRedirects from '../redirectManagement/initializeObeyBackendRedirects';
import trackGlobalEventsEffect from './trackGlobalEventsEffect';

initializeHistoryApiIntegration();
initializeObeyBackendRedirects();
trackGlobalEventsEffect();
